import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
//import Button from '@material-ui/core/Button';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import DataReactTable from './DataReactTable';
import "moment/locale/es";
import { Col, Card, CardBody, Button } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import history from '../../../history';

class EventAdverseList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            studiesList: [],
            adverstList: [],
        }
    }

    componentDidMount() {
        this.loadDataStudies();
        this.loadDataEventAdverse();

    }

    loadDataStudies = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'estudiosc/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.existe) {
                    this.setState({ studiesList: data.contenido });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadDataEventAdverse = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'evento-adverso-estudio/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                //this.setState({ adverstList: data });
                this.filterData(data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    filterData = (data) => {

        let orderData = [];

        for (let i = 0; i < data.length; i++) {
            console.log("eje");
            orderData[i] = {
                fecha_recepcion: moment(data[i].fecha_recepcion).format('L'),
                fecha_reporte: moment(data[i].fecha_reporte).format('L'),
                tipo_reporte: data[i].tipo_reporte === '1' ? "Inicial" :
                    data[i].tipo_reporte === '2' ? "Seguimiento" :
                        "Final",
                clasificacion_evento: data[i].clasificacion_evento === '1' ? "CIOMS" : "",
                id_estudio: data[i].id_estudio,
                id_tercero: data[i].id_tercero,
                id_event_adv: data[i].id_event_adv

            }
        }
        console.log(orderData);

        this.setState({ adverstList: orderData, isLoading: false });

    }
    
    render() {

        const reactTableData = {
            tableHeaderData: [
                {
                    Header: 'FECHA DE REPORTE',
                    accessor: 'fecha_reporte',
                    disableGlobalFilter: true,
                    width: 65,
                },
                {
                    Header: 'ESTUDIO CLINICO',
                    accessor: 'id_estudio',
                },
                {
                    Header: 'PATROCINADOR',
                    accessor: 'id_tercero',
                },
                {
                    Header: 'ID EVENTO',
                    accessor: 'id',
                },
                {
                    Header: 'TIPO DE REPORTE',
                    accessor: 'tipo_reporte',
                },
                {
                    Header: 'FECHA DE RECEPCION',
                    accessor: 'fecha_recepcion',
                },
                {
                    Header: 'FECHA DE REGISTRO',
                    accessor: 'fecha_registro',
                },
            ],
            tableRowsData: this.state.adverstList
        };

        return (
            <Card>
                <CardBody>
                    <Col>
                        <div style={{ flex: 1, flexDirection: 'row' }}>
                            <form className="material-form" >
                                <div style={{ flex: 1, flexDirection: 'row' }}>

                                    <TextField
                                        className="material-form__field"
                                        label="Estudio Clinico"
                                        id="studio-select"
                                        style={{ width: 200, margin: 10 }}
                                        select
                                        defaultValue={null}
                                        onChange={(event) => {
                                            console.log(event);
                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                    </TextField>
                                    <TextField
                                        required
                                        className="material-form__field"
                                        style={{ width: 200, margin: 10 }}
                                        id="id-standard"
                                        label="Id Evento"
                                        type="number"

                                        onChange={(e) => {

                                        }}

                                    />
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            label="Fecha Inicial"
                                            className="material-form__field"
                                            onChange={(date) => {

                                            }}
                                            format="yyyy/MM/DD"
                                            animateYearScrolling
                                            className="material-form__field"
                                            style={{ width: 200, margin: 10 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}

                                        />
                                    </MuiPickersUtilsProvider>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            label="Fecha Final"
                                            className="material-form__field"
                                            onChange={(date) => {

                                            }}
                                            format="yyyy/MM/DD"
                                            animateYearScrolling
                                            className="material-form__field"
                                            style={{ width: 200, margin: 10 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}

                                        />
                                    </MuiPickersUtilsProvider>
                                    <TextField
                                        className="material-form__field"
                                        label="Estado"
                                        id="studio-select"
                                        style={{ width: 200, margin: 5 }}
                                        select
                                        defaultValue={null}
                                        onChange={(event) => {
                                            console.log(event);

                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={1} value={1}>Activo</MenuItem>
                                        <MenuItem className="material-form__option" key={2} value={2}>Incativo</MenuItem>
                                    </TextField>


                                    <Tooltip title="Buscar">
                                        <Button
                                            outline
                                            style={{ marginLeft: 20, }}
                                            onClick={() => {

                                            }}
                                        >
                                            <SearchIcon />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Adicionar">
                                        <Button
                                            outline
                                            style={{ marginLeft: 10 }}
                                            onClick={() => {
                                                history.push({
                                                    pathname: process.env.PUBLIC_URL + '/assitencial/addeventadverse',
                                                });
                                            }}
                                        >
                                            <AddIcon />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Reportar">
                                        <Button
                                            outline
                                            style={{ marginLeft: 10 }}
                                            onClick={() => {
                                                history.push({
                                                    pathname: process.env.PUBLIC_URL + '/assitencial/reporteventadverse',
                                                });
                                            }}
                                        >
                                            <ReportProblemIcon />
                                        </Button>
                                    </Tooltip>

                                </div>
                            </form>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            </div>
                            <div style={{ marginTop: 10 }}>
                                {this.state.isLoading ?
                                    <div className="text-center">
                                        <Spinner animation="border" variant="success" />
                                    </div>
                                    : <DataReactTable reactTableData={reactTableData} title={''} />}

                            </div>
                        </div>
                    </Col>
                </CardBody>
            </Card>)
    }
}

export default EventAdverseList;